import { connect } from 'react-redux';
import * as R from 'ramda';

import {
  getStoreValueByProp,
  setAreAllCustomersAllowed,
  setSelectCustomersSearchTerm,
  setSelectedCustomers,
} from '../../store/createNewCarrierAuthSlice';
import SelectCustomers from './SelectCustomers';

const mapState = R.applySpec({
  areAllCustomersAllowed: getStoreValueByProp(['areAllCustomersAllowed']),
  customersList: getStoreValueByProp(['customersList']),
  isCustomersListPending: getStoreValueByProp(['isCustomersListPending']),
  quickFilterInput: getStoreValueByProp(['selectCustomersSearchTerm']),
  selectedCustomers: getStoreValueByProp(['selectedCustomers']),
});

const mapDispatchToProps = {
  setAreAllCustomersAllowed,
  setSelectCustomersSearchTerm,
  setSelectedCustomers,
};

export default connect(mapState, mapDispatchToProps)(SelectCustomers);
